module.exports = __webpack_public_path__ + "img/home.5da87556.jpg";